import { FONT } from './font';
import { IMAGE } from './image';
import { BACKGROUND } from './background';
import { VIDEO } from './video';

export const initialConfig = {
  FONT,
  IMAGE,
  BACKGROUND,
  VIDEO,
};
